import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const chapterChangesStyle = css`
	.attributeChangeBlock {
		margin-bottom: 10px;
	}

	.label {
		color: ${colors.infoText};
		margin-bottom: 5px;
	}

	.badge {
		margin-left: 10px;
	}
`;

export const headerStyle = css`
	font-size: 16px;
	font-weight: 600;
	color: ${colors.mainText};
	margin-bottom: 10px;

	display: flex;
	align-items: center;

	.badge {
		margin-left: 10px;
	}

	.caretDownIcon {
		color: lightgray;
		margin-left: 10px;

		:hover {
			cursor: pointer;
			color: ${colors.hoverText};
		}
	}

	.title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
	}
`;

export const chapterHeader = css`
	border-top: 1px solid ${colors.border};
	padding-top: 15px;

	font-size: 16px;
`;

export const pageGroupHeader = css`
	font-size: 14px;
`;

export const pageHeader = css`
	font-size: 14px;
`;

export const elementHeader = css`
	font-size: 14px;
`;

export const childrenChangesBlock = css`
	padding-left: 15px;
	position: relative;
`;

export const childrenSubtree = css`
	position: absolute;
	width: 12px;
	border-left: 1px solid lightgray;
	height: 100%;
	top: 0px;
	left: 0px;

	:hover {
		border-left: 2px solid lightblue;
		cursor: pointer;
	}
`;

export const expandChangesButton = css`
	font-size: 14px !important;
	padding: 0 !important;
	margin-bottom: 5px;
`;
